import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap w-11 md:w-4 list-none p-2 m-2 surface-ground" }
const _hoisted_2 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }
const _hoisted_3 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }
const _hoisted_4 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }
const _hoisted_5 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }
const _hoisted_6 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }
const _hoisted_7 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }
const _hoisted_8 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }
const _hoisted_9 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }
const _hoisted_10 = { class: "flex justify-content-center align-items-center ml-1 mt-2 mb-4 h-6rem" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ height: `${$data.vh - 170}px` }),
    class: "flex align-items-center justify-content-center pt-3 pb-3"
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/scan-item",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Skenovať QR kód",
              severity: "success",
              icon: "pi pi-camera",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/products/0",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Pridať produkt",
              severity: "success",
              icon: "pi pi-plus",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/boxies/0",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Pridať krabicu",
              severity: "success",
              icon: "pi pi-plus",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/packages/0",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Pridať balík",
              severity: "success",
              icon: "pi pi-plus",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/stock-items/0",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Pridať kus",
              severity: "success",
              icon: "pi pi-plus",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/bulk-add-items",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Hromadné pridanie kusov",
              severity: "success",
              icon: "pi pi-plus",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/search-items",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Vyhľadávanie a rezervácia kusov",
              severity: "success",
              icon: "pi pi-search-plus",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/reservation-requests/1",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Žiadosti o rezervácie",
              severity: "success",
              icon: "pi pi-calendar-plus",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createVNode(_component_router_link, {
          to: "/mod-stock/reservation-requests/2",
          class: "mr-2 h-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PrimevueButton, {
              label: "Žiadosti o prestriekanie",
              severity: "success",
              icon: "pi pi-calendar-plus",
              text: "",
              raised: "",
              class: "basic-menu uppercase h-full p-2"
            })
          ]),
          _: 1
        })
      ])
    ])
  ], 4))
}